document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.ev-menu-toggle');
  const nav = document.querySelector('#EVNav');
  if (toggle && nav) {
    const closeNav = () => {
      toggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
    };

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open', !expanded);
    });

    nav.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    document.addEventListener('click', closeNav);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeNav();
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const featured = gallery.querySelector('[data-zoom-featured]');
    const stage = gallery.querySelector('.ev-product__stage');
    const thumbs = Array.from(gallery.querySelectorAll('.ev-product__thumb-button'));
    const mediaItems = Array.from(gallery.querySelectorAll('[data-gallery-media]'));
    const counter = gallery.querySelector('[data-gallery-counter]');
    const prevButton = gallery.querySelector('.ev-product__gallery-arrow--prev');
    const nextButton = gallery.querySelector('.ev-product__gallery-arrow--next');
    const zoomLens = gallery.querySelector('[data-zoom-lens]');
    const zoomPane = gallery.querySelector('[data-zoom-pane]');
    const zoomPaneImage = zoomPane ? zoomPane.querySelector('img') : null;
    const zoomModal = gallery.querySelector('[data-zoom-modal]');
    const zoomModalImage = gallery.querySelector('[data-zoom-modal-image]');
    const zoomModalCounter = gallery.querySelector('[data-zoom-modal-counter]');
    const zoomClose = gallery.querySelector('[data-zoom-close]');
    const zoomPrev = gallery.querySelector('[data-zoom-modal-prev]');
    const zoomNext = gallery.querySelector('[data-zoom-modal-next]');
    const finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!featured || !mediaItems.length || !thumbs.length) return;

    let activeIndex = Math.max(0, mediaItems.findIndex((item) => item.classList.contains('is-active')));
    let touchStartX = 0;
    let touchStartY = 0;
    let touchLastX = 0;
    let touchLastY = 0;
    let modalTouchStartX = 0;
    let modalTouchStartY = 0;
    let suppressModalClick = false;
    let slideCleanupTimer = null;
    let isDragging = false;
    let dragDirection = 0;
    let dragCandidateIndex = -1;
    const mediaPreloaders = new Map();
    const allMediaIndexes = mediaItems.map((_, index) => index);
    let visibleMediaIndexes = allMediaIndexes.slice();

    const normalizeIndex = (index) => (index + mediaItems.length) % mediaItems.length;
    const isVisibleMediaIndex = (index) => visibleMediaIndexes.includes(normalizeIndex(index));
    const getVisiblePosition = (index) => visibleMediaIndexes.indexOf(normalizeIndex(index));
    const getVisibleCount = () => visibleMediaIndexes.length || mediaItems.length;
    const getAdjacentVisibleIndex = (fromIndex, direction = 1) => {
      if (!visibleMediaIndexes.length) return normalizeIndex(fromIndex + direction);
      const currentPosition = getVisiblePosition(fromIndex);
      if (currentPosition < 0) return visibleMediaIndexes[0];
      const nextPosition = (currentPosition + (direction > 0 ? 1 : -1) + visibleMediaIndexes.length) % visibleMediaIndexes.length;
      return visibleMediaIndexes[nextPosition];
    };
    const resolveTargetIndex = (index, direction = 0) => {
      const normalized = normalizeIndex(index);
      if (isVisibleMediaIndex(normalized)) return normalized;
      if (!visibleMediaIndexes.length) return normalized;
      return getAdjacentVisibleIndex(activeIndex, direction || 1);
    };

    const getActiveItem = () => mediaItems[activeIndex] || null;
    const getActiveImage = () => {
      const activeItem = getActiveItem();
      return activeItem ? activeItem.querySelector('.ev-product__main-image') : null;
    };
    const isInteractiveMediaTarget = (target) => Boolean(target && target.closest('video, iframe, .ev-product__main-video, .ev-product__external-video'));
    const isActiveImageMedia = () => {
      const activeItem = getActiveItem();
      return activeItem && activeItem.getAttribute('data-media-type') !== 'video' && activeItem.getAttribute('data-media-type') !== 'external_video' && !!getActiveImage();
    };

    const getDirection = (targetIndex, fromIndex = activeIndex) => {
      const target = normalizeIndex(targetIndex);
      const from = normalizeIndex(fromIndex);
      if (target === from || getVisibleCount() < 2) return 0;

      const targetPosition = getVisiblePosition(target);
      const fromPosition = getVisiblePosition(from);
      if (targetPosition >= 0 && fromPosition >= 0) {
        const visibleCount = getVisibleCount();
        const forwardDistance = (targetPosition - fromPosition + visibleCount) % visibleCount;
        const backwardDistance = (fromPosition - targetPosition + visibleCount) % visibleCount;
        return forwardDistance <= backwardDistance ? 1 : -1;
      }

      const forwardDistance = (target - from + mediaItems.length) % mediaItems.length;
      const backwardDistance = (from - target + mediaItems.length) % mediaItems.length;
      return forwardDistance <= backwardDistance ? 1 : -1;
    };

    const getImageData = (index) => {
      const thumbButton = thumbs[normalizeIndex(index)];
      if (!thumbButton) return null;
      return {
        full: thumbButton.getAttribute('data-full') || '',
        zoom: thumbButton.getAttribute('data-zoom') || thumbButton.getAttribute('data-full') || '',
        srcset: thumbButton.getAttribute('data-srcset') || '',
        alt: thumbButton.getAttribute('data-alt') || '',
        mediaType: thumbButton.getAttribute('data-media-type') || 'image'
      };
    };

    const unhideMediaItem = (item) => {
      if (!item) return;
      item.hidden = false;
      item.removeAttribute('hidden');
    };

    const preloadMedia = (index) => {
      const normalizedIndex = normalizeIndex(index);
      const item = mediaItems[normalizedIndex];
      if (!item) return;
      const image = item.querySelector('.ev-product__main-image');
      if (!image) return;
      if (image.complete && image.naturalWidth > 0) return;

      const src = image.currentSrc || image.getAttribute('src');
      if (!src) return;
      const key = `${normalizedIndex}:${src}`;
      if (mediaPreloaders.has(key)) return;

      image.setAttribute('loading', 'eager');
      try { image.fetchPriority = 'high'; } catch (error) { /* Older browsers can ignore fetch priority. */ }

      const preloader = new Image();
      const srcset = image.getAttribute('srcset');
      const sizes = image.getAttribute('sizes');
      if (srcset) preloader.srcset = srcset;
      if (sizes) preloader.sizes = sizes;
      preloader.src = src;
      mediaPreloaders.set(key, preloader);
    };

    const preloadNearbyMedia = (index) => {
      preloadMedia(index);
      preloadMedia(getAdjacentVisibleIndex(index, 1));
      preloadMedia(getAdjacentVisibleIndex(index, -1));
      preloadMedia(getAdjacentVisibleIndex(getAdjacentVisibleIndex(index, 1), 1));
      preloadMedia(getAdjacentVisibleIndex(getAdjacentVisibleIndex(index, -1), -1));
    };

    const clearSlideClasses = () => {
      if (slideCleanupTimer) {
        window.clearTimeout(slideCleanupTimer);
        slideCleanupTimer = null;
      }
      featured.classList.remove('is-ev-smooth-switching', 'is-dragging');
      mediaItems.forEach((item) => {
        item.classList.remove(
          'ev-slide-active',
          'ev-slide-leaving',
          'ev-slide-enter-next',
          'ev-slide-enter-prev',
          'ev-slide-to-left',
          'ev-slide-to-right',
          'ev-slide-animate',
          'ev-drag-current',
          'ev-drag-candidate'
        );
        item.style.removeProperty('transform');
        item.style.removeProperty('opacity');
        item.style.removeProperty('transition');
        item.style.removeProperty('z-index');
      });
    };

    const lockFeaturedHeight = (item) => {
      if (!featured) return;
      const itemRect = item ? item.getBoundingClientRect() : null;
      const featuredRect = featured.getBoundingClientRect();
      let height = itemRect && itemRect.height > 20 ? itemRect.height : featuredRect.height;

      if ((!height || height <= 20) && item) {
        const media = item.querySelector('img, video, iframe');
        const width = (featuredRect && featuredRect.width) || (itemRect && itemRect.width) || 0;
        const attrWidth = media ? parseFloat(media.getAttribute('width') || '0') : 0;
        const attrHeight = media ? parseFloat(media.getAttribute('height') || '0') : 0;
        if (width && attrWidth && attrHeight) height = width * (attrHeight / attrWidth);
        else if (width) height = width;
      }

      if (height && height > 20) {
        const lockedHeight = `${Math.ceil(height)}px`;
        featured.style.height = lockedHeight;
        featured.style.minHeight = lockedHeight;
      }
    };

    const releaseFeaturedHeight = () => {
      if (!featured.classList.contains('is-ev-smooth-switching') && !featured.classList.contains('is-dragging')) {
        featured.style.removeProperty('height');
        featured.style.removeProperty('min-height');
      }
    };

    const showOnlyActive = () => {
      mediaItems.forEach((item, itemIndex) => {
        const isVisible = isVisibleMediaIndex(itemIndex);
        const isActive = isVisible && itemIndex === activeIndex;
        item.classList.toggle('is-active', isActive);
        item.classList.toggle('is-filtered-out', !isVisible);
        if (isActive) unhideMediaItem(item);
        else item.hidden = true;
      });
    };

    const pauseInactiveMedia = () => {
      mediaItems.forEach((item, itemIndex) => {
        if (itemIndex === activeIndex) return;
        item.querySelectorAll('video').forEach((video) => {
          try { video.pause(); } catch (error) { /* Keep gallery resilient. */ }
        });
      });
    };

    const resetInlineZoom = () => {
      featured.classList.remove('is-inline-zooming', 'is-zooming');
      if (stage) stage.classList.remove('is-zooming');
      mediaItems.forEach((item) => {
        item.querySelectorAll('.ev-product__main-image').forEach((image) => {
          image.classList.remove('is-changing');
          image.style.removeProperty('transform');
          image.style.removeProperty('transform-origin');
        });
      });
      if (zoomLens) {
        zoomLens.style.removeProperty('left');
        zoomLens.style.removeProperty('top');
      }
      if (zoomPane) zoomPane.setAttribute('aria-hidden', 'true');
    };

    const refreshZoomImages = (imageData) => {
      const activeImage = getActiveImage();
      const zoomSource = activeImage ? (activeImage.getAttribute('data-zoom-image') || imageData?.zoom || imageData?.full || activeImage.currentSrc || activeImage.src) : '';
      const alt = activeImage ? activeImage.getAttribute('alt') || imageData?.alt || 'Product image preview' : imageData?.alt || 'Product image preview';

      if (activeImage && zoomSource) activeImage.setAttribute('data-zoom-image', zoomSource);
      if (zoomPaneImage && zoomSource) zoomPaneImage.setAttribute('src', zoomSource);
      if (zoomModalImage && zoomSource) {
        zoomModalImage.setAttribute('src', zoomSource);
        zoomModalImage.setAttribute('alt', alt);
      }
    };

    const updateControls = () => {
      const visibleCount = getVisibleCount();
      const activeVisiblePosition = Math.max(0, getVisiblePosition(activeIndex));

      thumbs.forEach((button, buttonIndex) => {
        const isVisible = isVisibleMediaIndex(buttonIndex);
        const isActive = isVisible && buttonIndex === activeIndex;
        button.hidden = !isVisible;
        button.classList.toggle('is-filtered-out', !isVisible);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-hidden', String(!isVisible));
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (counter) {
        counter.textContent = `${activeVisiblePosition + 1} / ${visibleCount}`;
        counter.hidden = visibleCount <= 1;
      }
      if (zoomModalCounter) {
        zoomModalCounter.textContent = `${activeVisiblePosition + 1} / ${visibleCount}`;
        zoomModalCounter.hidden = visibleCount <= 1;
      }
      [prevButton, nextButton, zoomPrev, zoomNext].forEach((button) => {
        if (button) button.hidden = visibleCount <= 1;
      });

      featured.classList.toggle('ev-product__featured--video-active', !isActiveImageMedia());
      featured.setAttribute('aria-label', isActiveImageMedia() ? 'Open larger product image' : 'Product video preview');
    };

    const closeModal = () => {
      if (!zoomModal) return;
      zoomModal.classList.remove('is-open');
      zoomModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ev-zoom-open');
      if (featured) featured.focus({ preventScroll: true });
    };

    const finishSlide = () => {
      showOnlyActive();
      clearSlideClasses();
      pauseInactiveMedia();
      window.setTimeout(releaseFeaturedHeight, 40);
      preloadNearbyMedia(activeIndex);
    };

    const setActiveMedia = (index, options = {}) => {
      const previousIndex = activeIndex;
      const targetIndex = resolveTargetIndex(index, options.direction || 0);
      const previousItem = mediaItems[previousIndex];
      const nextItem = mediaItems[targetIndex];
      if (!nextItem) return;

      const isSameMedia = targetIndex === previousIndex;
      if (isSameMedia) {
        refreshZoomImages(getImageData(activeIndex));
        updateControls();
        preloadNearbyMedia(activeIndex);
        if (thumbs[activeIndex]) {
          thumbs[activeIndex].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: options.instant ? 'auto' : 'smooth' });
        }
        return;
      }

      const direction = options.direction || getDirection(targetIndex, previousIndex) || 1;
      const shouldAnimate = !options.instant && !reducedMotion && previousItem && nextItem && mediaItems.length > 1;

      preloadMedia(targetIndex);
      resetInlineZoom();
      clearSlideClasses();
      activeIndex = targetIndex;

      if (shouldAnimate) {
        lockFeaturedHeight(previousItem);
        featured.classList.add('is-ev-smooth-switching');

        mediaItems.forEach((item, itemIndex) => {
          const isVisible = isVisibleMediaIndex(itemIndex);
          const shouldShow = isVisible && (itemIndex === previousIndex || itemIndex === targetIndex);
          if (shouldShow) unhideMediaItem(item);
          else item.hidden = true;
          item.classList.toggle('is-filtered-out', !isVisible);
          item.classList.toggle('is-active', isVisible && itemIndex === targetIndex);
        });

        previousItem.classList.add('ev-slide-leaving');
        nextItem.classList.add('ev-slide-active', direction > 0 ? 'ev-slide-enter-next' : 'ev-slide-enter-prev');
        previousItem.style.setProperty('transform', 'translate3d(0,0,0)', 'important');
        nextItem.style.setProperty('transform', direction > 0 ? 'translate3d(100%,0,0)' : 'translate3d(-100%,0,0)', 'important');

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const nextHeight = nextItem.getBoundingClientRect().height;
            if (nextHeight > 20) featured.style.height = `${Math.ceil(nextHeight)}px`;

            previousItem.classList.add('ev-slide-animate', direction > 0 ? 'ev-slide-to-left' : 'ev-slide-to-right');
            nextItem.classList.add('ev-slide-animate');
            nextItem.classList.remove('ev-slide-enter-next', 'ev-slide-enter-prev');
            previousItem.style.setProperty('transform', direction > 0 ? 'translate3d(-100%,0,0)' : 'translate3d(100%,0,0)', 'important');
            nextItem.style.setProperty('transform', 'translate3d(0,0,0)', 'important');
          });
        });

        const finishOnce = () => finishSlide();
        nextItem.addEventListener('transitionend', finishOnce, { once: true });
        slideCleanupTimer = window.setTimeout(finishOnce, 560);
      } else {
        showOnlyActive();
        window.setTimeout(releaseFeaturedHeight, 40);
      }

      pauseInactiveMedia();
      refreshZoomImages(getImageData(activeIndex));
      updateControls();
      preloadNearbyMedia(activeIndex);

      if (thumbs[activeIndex]) {
        thumbs[activeIndex].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: options.instant ? 'auto' : 'smooth' });
      }

      if (zoomModal && zoomModal.classList.contains('is-open') && !isActiveImageMedia()) closeModal();
    };

    const mediaFilterEnabled = gallery.getAttribute('data-variant-media-filter') === 'true';
    const mediaFilterOptionName = (gallery.getAttribute('data-filter-option-name') || '').trim();
    const mediaFilterShowGeneral = gallery.getAttribute('data-filter-show-general') !== 'false';
    const mediaFilterGeneralKeywords = (gallery.getAttribute('data-filter-general-keywords') || 'all,general,common,default,通用,全部')
      .split(',')
      .map((keyword) => keyword.trim().toLowerCase())
      .filter(Boolean);

    const normalizeFilterText = (value) => String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[\s_\-–—/|:;,.()[\]{}'"+]+/g, '');

    const getMediaFilterText = (index) => {
      const item = mediaItems[normalizeIndex(index)];
      const thumb = thumbs[normalizeIndex(index)];
      return [
        item ? item.getAttribute('data-filter-text') : '',
        thumb ? thumb.getAttribute('data-filter-text') : '',
        thumb ? thumb.getAttribute('data-alt') : ''
      ].filter(Boolean).join(' ');
    };

    const isGeneralMedia = (index) => {
      const text = getMediaFilterText(index).toLowerCase();
      if (!text) return false;
      const tokens = text.split(/[\s_\-–—/|:;,.()[\]{}'"+]+/g).filter(Boolean);
      return mediaFilterGeneralKeywords.some((keyword) => {
        if (!keyword) return false;
        if (/[^\x00-\x7F]/.test(keyword)) return text.includes(keyword);
        return tokens.includes(keyword) || text.includes(`[${keyword}]`) || text.includes(`${keyword}:`) || text.includes(`${keyword}=`);
      });
    };

    const mediaMatchesSelectedValue = (index, selectedValue, optionName = '') => {
      const text = getMediaFilterText(index);
      if (!text || !selectedValue) return false;

      const lowerText = text.toLowerCase();
      const lowerValue = String(selectedValue).toLowerCase().trim();
      const normalizedText = normalizeFilterText(text);
      const normalizedValue = normalizeFilterText(selectedValue);
      const optionTokens = [
        optionName,
        mediaFilterOptionName,
        'style',
        'product style',
        'type',
        'model',
        'color',
        'colour',
        'material',
        'shape',
        'size',
        '样式',
        '款式',
        '风格',
        '颜色',
        '材质',
        '形状',
        '尺寸'
      ].map((token) => String(token || '').toLowerCase().trim()).filter(Boolean);
      const uniqueTokens = [...new Set(optionTokens)];

      const hasTaggedMatch = uniqueTokens.some((token) => {
        const compactToken = normalizeFilterText(token);
        const compactTagged = `${compactToken}${normalizedValue}`;
        return lowerText.includes(`[${token}: ${lowerValue}]`)
          || lowerText.includes(`${token}: ${lowerValue}`)
          || lowerText.includes(`${token}=${lowerValue}`)
          || lowerText.includes(`${token}-${lowerValue}`)
          || lowerText.includes(`${token} / ${lowerValue}`)
          || normalizedText.includes(compactTagged);
      });

      return hasTaggedMatch || normalizedText.includes(normalizedValue);
    };

    const chooseFilterOptionIndex = (optionNames = []) => {
      const normalizedNames = optionNames.map((name) => String(name || '').trim().toLowerCase());
      const requested = mediaFilterOptionName.toLowerCase();

      if (requested) {
        const exactIndex = normalizedNames.findIndex((name) => name === requested);
        if (exactIndex >= 0) return exactIndex;
        const includesIndex = normalizedNames.findIndex((name) => name.includes(requested) || requested.includes(name));
        if (includesIndex >= 0) return includesIndex;
      }

      const preferredNames = ['style', 'product style', 'type', 'model', 'shape', 'color', 'colour', 'material', '样式', '款式', '风格', '形状', '颜色', '材质'];
      const preferredIndex = normalizedNames.findIndex((name) => preferredNames.some((preferred) => name === preferred || name.includes(preferred)));
      return preferredIndex >= 0 ? preferredIndex : 0;
    };

    const applyMediaFilterFromVariant = (detail = {}) => {
      const featuredMediaIndex = Number(detail.featuredMediaIndex);

      if (!mediaFilterEnabled) {
        if (Number.isInteger(featuredMediaIndex) && featuredMediaIndex >= 0 && mediaItems[featuredMediaIndex]) {
          setActiveMedia(featuredMediaIndex, { instant: true });
        }
        return;
      }

      const selectedValues = Array.isArray(detail.selectedValues) ? detail.selectedValues.map(String) : [];
      const optionNames = Array.isArray(detail.optionNames) ? detail.optionNames.map(String) : [];
      const optionIndex = chooseFilterOptionIndex(optionNames);
      const selectedValue = selectedValues[optionIndex] || '';
      const selectedOptionName = optionNames[optionIndex] || mediaFilterOptionName || '';

      if (!selectedValue) {
        visibleMediaIndexes = allMediaIndexes.slice();
      } else {
        const matchedIndexes = allMediaIndexes.filter((index) => mediaMatchesSelectedValue(index, selectedValue, selectedOptionName));
        const generalIndexes = mediaFilterShowGeneral ? allMediaIndexes.filter(isGeneralMedia) : [];
        const nextVisible = allMediaIndexes.filter((index) => matchedIndexes.includes(index) || generalIndexes.includes(index));
        visibleMediaIndexes = nextVisible.length ? nextVisible : allMediaIndexes.slice();
      }

      thumbs.forEach((button, buttonIndex) => {
        const isVisible = isVisibleMediaIndex(buttonIndex);
        button.hidden = !isVisible;
        button.classList.toggle('is-filtered-out', !isVisible);
        button.setAttribute('aria-hidden', String(!isVisible));
      });

      mediaItems.forEach((item, itemIndex) => {
        const isVisible = isVisibleMediaIndex(itemIndex);
        item.classList.toggle('is-filtered-out', !isVisible);
        if (!isVisible) {
          item.hidden = true;
          item.classList.remove('is-active');
        }
      });

      let targetIndex = activeIndex;
      if (Number.isInteger(featuredMediaIndex) && featuredMediaIndex >= 0 && isVisibleMediaIndex(featuredMediaIndex)) {
        targetIndex = featuredMediaIndex;
      } else if (!isVisibleMediaIndex(activeIndex)) {
        targetIndex = visibleMediaIndexes[0] || 0;
      }

      if (targetIndex !== activeIndex || !isVisibleMediaIndex(activeIndex)) {
        setActiveMedia(targetIndex, { instant: true });
      } else {
        showOnlyActive();
        refreshZoomImages(getImageData(activeIndex));
        updateControls();
        preloadNearbyMedia(activeIndex);
      }
    };

    document.addEventListener('ev:variant:change', (event) => {
      applyMediaFilterFromVariant(event.detail || {});
    });

    const moveInlineZoom = (event) => {
      if (!finePointer || !isActiveImageMedia() || featured.classList.contains('is-ev-smooth-switching')) return;
      const activeImage = getActiveImage();
      if (!activeImage) return;
      const rect = featured.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const x = Math.max(0, Math.min(event.clientX - rect.left, rect.width));
      const y = Math.max(0, Math.min(event.clientY - rect.top, rect.height));
      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;
      const lensSize = Math.max(96, Math.min(150, rect.width * 0.22));

      featured.classList.add('is-inline-zooming', 'is-zooming');
      if (stage) stage.classList.add('is-zooming');
      activeImage.style.setProperty('transform-origin', `${xPercent}% ${yPercent}%`);
      activeImage.style.setProperty('transform', 'scale(2.02)', 'important');

      if (zoomLens) {
        zoomLens.style.width = `${lensSize}px`;
        zoomLens.style.height = `${lensSize}px`;
        zoomLens.style.left = `${x}px`;
        zoomLens.style.top = `${y}px`;
      }
    };

    const openModal = () => {
      if (!zoomModal || !isActiveImageMedia() || featured.classList.contains('is-ev-smooth-switching')) return;
      refreshZoomImages(getImageData(activeIndex));
      updateControls();
      zoomModal.classList.add('is-open');
      zoomModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ev-zoom-open');
      if (zoomClose) zoomClose.focus({ preventScroll: true });
    };

    const prepareDrag = (direction) => {
      if (!stage || mediaItems.length < 2) return false;
      const currentItem = getActiveItem();
      const candidateIndex = getAdjacentVisibleIndex(activeIndex, direction);
      const candidateItem = mediaItems[candidateIndex];
      if (!currentItem || !candidateItem || currentItem === candidateItem) return false;

      preloadMedia(candidateIndex);
      resetInlineZoom();
      clearSlideClasses();
      lockFeaturedHeight(currentItem);
      featured.classList.add('is-dragging', 'is-ev-smooth-switching');
      isDragging = true;
      dragDirection = direction;
      dragCandidateIndex = candidateIndex;

      mediaItems.forEach((item, itemIndex) => {
        const isVisible = isVisibleMediaIndex(itemIndex);
        const shouldShow = isVisible && (itemIndex === activeIndex || itemIndex === candidateIndex);
        if (shouldShow) unhideMediaItem(item);
        else item.hidden = true;
        item.classList.toggle('is-filtered-out', !isVisible);
        item.classList.toggle('is-active', isVisible && itemIndex === activeIndex);
      });

      currentItem.classList.add('ev-drag-current');
      candidateItem.classList.add('ev-drag-candidate');
      candidateItem.style.setProperty('z-index', '2');
      currentItem.style.setProperty('z-index', '1');
      return true;
    };

    const updateDrag = (deltaX) => {
      if (!isDragging || dragCandidateIndex < 0) return;
      const currentItem = getActiveItem();
      const candidateItem = mediaItems[dragCandidateIndex];
      const rect = featured.getBoundingClientRect();
      if (!currentItem || !candidateItem || !rect.width) return;

      const width = rect.width;
      const clamped = Math.max(-width, Math.min(width, deltaX));
      const candidateX = clamped + (dragDirection > 0 ? width : -width);
      currentItem.style.setProperty('transform', `translate3d(${clamped}px,0,0)`, 'important');
      candidateItem.style.setProperty('transform', `translate3d(${candidateX}px,0,0)`, 'important');
    };

    const cancelDrag = () => {
      const currentItem = getActiveItem();
      const candidateItem = mediaItems[dragCandidateIndex];
      const rect = featured.getBoundingClientRect();
      const width = rect.width || 1;

      if (!currentItem || !candidateItem) {
        isDragging = false;
        dragCandidateIndex = -1;
        showOnlyActive();
        clearSlideClasses();
        releaseFeaturedHeight();
        return;
      }

      currentItem.classList.add('ev-slide-animate');
      candidateItem.classList.add('ev-slide-animate');
      currentItem.style.setProperty('transform', 'translate3d(0,0,0)', 'important');
      candidateItem.style.setProperty('transform', `translate3d(${dragDirection > 0 ? width : -width}px,0,0)`, 'important');

      window.setTimeout(() => {
        isDragging = false;
        dragCandidateIndex = -1;
        showOnlyActive();
        clearSlideClasses();
        releaseFeaturedHeight();
      }, 260);
    };

    thumbs.forEach((thumbButton, index) => {
      thumbButton.addEventListener('click', () => setActiveMedia(index));
    });

    if (prevButton) prevButton.addEventListener('click', () => setActiveMedia(activeIndex - 1, { direction: -1 }));
    if (nextButton) nextButton.addEventListener('click', () => setActiveMedia(activeIndex + 1, { direction: 1 }));
    if (zoomPrev) zoomPrev.addEventListener('click', () => setActiveMedia(activeIndex - 1, { direction: -1 }));
    if (zoomNext) zoomNext.addEventListener('click', () => setActiveMedia(activeIndex + 1, { direction: 1 }));
    if (zoomClose) zoomClose.addEventListener('click', closeModal);

    if (zoomModal) {
      zoomModal.addEventListener('click', (event) => {
        if (suppressModalClick) return;
        if (event.target === zoomModal || event.target === zoomModalImage) closeModal();
      });
    }

    featured.addEventListener('mouseenter', moveInlineZoom, { passive: true });
    featured.addEventListener('mousemove', moveInlineZoom, { passive: true });
    featured.addEventListener('mouseleave', resetInlineZoom, { passive: true });
    featured.addEventListener('click', (event) => {
      if (suppressModalClick || isInteractiveMediaTarget(event.target) || featured.classList.contains('is-dragging')) return;
      openModal();
    });
    featured.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        if (!isActiveImageMedia()) return;
        event.preventDefault();
        openModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!zoomModal || zoomModal.getAttribute('aria-hidden') === 'true') return;
      if (event.key === 'Escape') closeModal();
      if (event.key === 'ArrowLeft') setActiveMedia(activeIndex - 1, { direction: -1 });
      if (event.key === 'ArrowRight') setActiveMedia(activeIndex + 1, { direction: 1 });
    });

    if (stage && mediaItems.length > 1) {
      stage.addEventListener('touchstart', (event) => {
        if (isInteractiveMediaTarget(event.target)) return;
        if (!event.touches || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchLastX = touchStartX;
        touchLastY = touchStartY;
        isDragging = false;
        dragDirection = 0;
        dragCandidateIndex = -1;
      }, { passive: true });

      stage.addEventListener('touchmove', (event) => {
        if (isInteractiveMediaTarget(event.target)) return;
        const touch = event.touches && event.touches[0];
        if (!touch) return;
        touchLastX = touch.clientX;
        touchLastY = touch.clientY;

        const deltaX = touchLastX - touchStartX;
        const deltaY = touchLastY - touchStartY;
        const isHorizontalGesture = Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;
        if (!isHorizontalGesture) return;

        event.preventDefault();
        const direction = deltaX < 0 ? 1 : -1;
        if (!isDragging && !prepareDrag(direction)) return;
        if (isDragging && direction !== dragDirection && Math.abs(deltaX) > 18) {
          showOnlyActive();
          clearSlideClasses();
          prepareDrag(direction);
        }
        updateDrag(deltaX);
      }, { passive: false });

      stage.addEventListener('touchend', (event) => {
        if (isInteractiveMediaTarget(event.target)) return;
        const changedTouch = event.changedTouches && event.changedTouches[0];
        const endX = changedTouch ? changedTouch.clientX : touchLastX;
        const endY = changedTouch ? changedTouch.clientY : touchLastY;
        const deltaX = endX - touchStartX;
        const deltaY = endY - touchStartY;
        const width = featured.getBoundingClientRect().width || 1;
        const isHorizontalSwipe = Math.abs(deltaX) > Math.max(44, width * 0.16) && Math.abs(deltaX) > Math.abs(deltaY) * 1.12;

        if (isDragging) {
          suppressModalClick = true;
          window.setTimeout(() => { suppressModalClick = false; }, 360);
          const direction = dragDirection || (deltaX < 0 ? 1 : -1);
          if (isHorizontalSwipe) {
            isDragging = false;
            dragCandidateIndex = -1;
            setActiveMedia(activeIndex + direction, { direction });
          } else {
            cancelDrag();
          }
          return;
        }

        if (!isHorizontalSwipe) return;
        suppressModalClick = true;
        window.setTimeout(() => { suppressModalClick = false; }, 360);
        setActiveMedia(deltaX < 0 ? activeIndex + 1 : activeIndex - 1, { direction: deltaX < 0 ? 1 : -1 });
      }, { passive: true });

      stage.addEventListener('touchcancel', () => {
        if (isDragging) cancelDrag();
      }, { passive: true });
    }

    if (zoomModal && mediaItems.length > 1) {
      zoomModal.addEventListener('touchstart', (event) => {
        if (!event.touches || event.touches.length !== 1) return;
        modalTouchStartX = event.touches[0].clientX;
        modalTouchStartY = event.touches[0].clientY;
      }, { passive: true });

      zoomModal.addEventListener('touchend', (event) => {
        const changedTouch = event.changedTouches && event.changedTouches[0];
        if (!changedTouch) return;

        const deltaX = changedTouch.clientX - modalTouchStartX;
        const deltaY = changedTouch.clientY - modalTouchStartY;
        const isHorizontalSwipe = Math.abs(deltaX) > 44 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;

        if (!isHorizontalSwipe) return;
        suppressModalClick = true;
        window.setTimeout(() => { suppressModalClick = false; }, 320);
        setActiveMedia(deltaX < 0 ? activeIndex + 1 : activeIndex - 1, { direction: deltaX < 0 ? 1 : -1 });
      }, { passive: true });
    }

    showOnlyActive();
    setActiveMedia(activeIndex, { instant: true });
    preloadNearbyMedia(activeIndex);
  });

  document.querySelectorAll('.ev-file-field').forEach((field) => {
    const input = field.querySelector('.ev-file-input');
    const fileName = field.querySelector('.ev-file-name');
    if (!input || !fileName) return;

    const emptyText = field.getAttribute('data-file-empty') || 'No file selected';
    const selectedText = field.getAttribute('data-file-selected') || 'File selected';

    input.addEventListener('change', () => {
      const selectedFile = input.files && input.files.length > 0 ? input.files[0] : null;
      fileName.textContent = selectedFile ? (selectedFile.name || selectedText) : emptyText;
    });
  });

  document.querySelectorAll('.ev-product-form').forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const priceBox = document.querySelector('[data-variant-price]');
    const addButton = form.querySelector('[data-add-button]');
    const optionRoot = form.querySelector('[data-option-selectors]');
    const optionPickers = optionRoot ? Array.from(optionRoot.querySelectorAll('[data-option-picker]')) : [];

    if (!variantSelect || !priceBox || form.dataset.highVariantPicker === 'true') return;

    const variantOptions = Array.from(variantSelect.options);

    const parseVariantValues = (option) => {
      const raw = option.getAttribute('data-options') || '[]';
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.map(String) : [];
      } catch (error) {
        return option.textContent
          .replace(/\s+-\s+Sold out\s*$/i, '')
          .split(' / ')
          .map((part) => part.trim());
      }
    };

    const variants = variantOptions.map((option) => ({
      element: option,
      id: option.value,
      values: parseVariantValues(option),
      available: option.getAttribute('data-available') === 'true'
    }));
    const optionNames = optionPickers.map((picker) => picker.getAttribute('data-option-name') || '');

    const buildPriceHtml = (option) => {
      const price = option.getAttribute('data-price') || '';
      const comparePrice = option.getAttribute('data-compare-price') || '';
      const priceValue = Number(option.getAttribute('data-price-value') || 0);
      const comparePriceValue = Number(option.getAttribute('data-compare-price-value') || 0);

      if (comparePriceValue > priceValue && comparePrice) {
        const savePercent = Math.round(((comparePriceValue - priceValue) / comparePriceValue) * 100);
        return `<div class="ev-product__price-row"><span class="ev-price ev-price--sale">${price}</span><s class="ev-price-compare">${comparePrice}</s><span class="ev-price-save">Save ${savePercent}%</span></div>`;
      }

      return `<div class="ev-product__price-row"><span class="ev-price">${price}</span></div>`;
    };

    const closePicker = (picker) => {
      if (!picker) return;
      const button = picker.querySelector('[data-option-picker-button]');
      picker.classList.remove('is-open');
      if (button) button.setAttribute('aria-expanded', 'false');
    };

    const closeAllPickers = () => {
      optionPickers.forEach(closePicker);
    };

    const openPicker = (picker) => {
      if (!picker) return;
      const button = picker.querySelector('[data-option-picker-button]');
      closeAllPickers();
      picker.classList.add('is-open');
      if (button) button.setAttribute('aria-expanded', 'true');
    };

    const valuesEqual = (variantValues, selectedValues) => (
      selectedValues.every((value, index) => variantValues[index] === value)
    );

    const getSelectedValues = () => optionPickers.map((picker, index) => {
      const selected = picker.querySelector('[data-option-picker-option].is-selected');
      if (selected) return selected.getAttribute('data-value') || '';

      const currentVariant = variants.find((variant) => variant.id === variantSelect.value) || variants[0];
      return currentVariant && currentVariant.values[index] ? currentVariant.values[index] : '';
    });

    const findVariantByValues = (selectedValues) => (
      variants.find((variant) => valuesEqual(variant.values, selectedValues))
    );

    const selectPickerValue = (picker, value) => {
      const text = picker.querySelector('[data-option-picker-text]');
      const buttons = Array.from(picker.querySelectorAll('[data-option-picker-option]'));

      buttons.forEach((button) => {
        const isSelected = (button.getAttribute('data-value') || '') === value;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-selected', String(isSelected));
      });

      if (text) text.textContent = value;
    };

    const syncPickersToVariant = (variant) => {
      if (!variant) return;
      optionPickers.forEach((picker, index) => {
        selectPickerValue(picker, variant.values[index] || '');
      });
    };

    const updateUnavailableOptionButtons = () => {
      if (!optionPickers.length) return;
      const selectedValues = getSelectedValues();

      optionPickers.forEach((picker, pickerIndex) => {
        const buttons = Array.from(picker.querySelectorAll('[data-option-picker-option]'));

        buttons.forEach((button) => {
          const candidateValues = selectedValues.slice();
          candidateValues[pickerIndex] = button.getAttribute('data-value') || '';
          const matchingVariant = findVariantByValues(candidateValues);
          const impossible = !matchingVariant;

          button.disabled = impossible;
          button.classList.toggle('is-disabled', impossible);
          button.setAttribute('aria-disabled', String(impossible));
        });
      });
    };

    const setVariant = (variant) => {
      if (!variant) return;
      variantSelect.value = variant.id;
      syncPickersToVariant(variant);
      refreshVariantState();
    };

    function refreshVariantState(options = {}) {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (!selectedOption) return;

      priceBox.innerHTML = buildPriceHtml(selectedOption);

      const selectedVariant = variants.find((variant) => variant.id === selectedOption.value);
      syncPickersToVariant(selectedVariant);
      updateUnavailableOptionButtons();

      if (addButton) {
        const isAvailable = selectedOption.getAttribute('data-available') === 'true';
        addButton.disabled = !isAvailable;
        addButton.textContent = isAvailable
          ? (addButton.getAttribute('data-add-text') || 'Add to cart')
          : (addButton.getAttribute('data-sold-out-text') || 'Sold out');
      }

      if (options.skipMediaChange) return;

      const featuredMediaIndexRaw = selectedOption.getAttribute('data-featured-media-index');
      const featuredMediaIndex = featuredMediaIndexRaw !== null && featuredMediaIndexRaw !== '' ? Number(featuredMediaIndexRaw) : -1;
      form.dispatchEvent(new CustomEvent('ev:variant:change', {
        bubbles: true,
        detail: {
          variantId: selectedOption.value,
          selectedValues: selectedVariant ? selectedVariant.values : [],
          optionNames,
          featuredMediaIndex
        }
      }));
    }

    optionPickers.forEach((picker) => {
      const pickerButton = picker.querySelector('[data-option-picker-button]');
      const pickerMenu = picker.querySelector('[data-option-picker-menu]');
      const pickerOptions = Array.from(picker.querySelectorAll('[data-option-picker-option]'));
      const pickerIndex = Number(picker.getAttribute('data-option-index') || 0);

      if (pickerButton && pickerMenu) {
        pickerButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          picker.classList.contains('is-open') ? closePicker(picker) : openPicker(picker);
        });

        pickerMenu.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      }

      pickerOptions.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (button.disabled) return;

          const value = button.getAttribute('data-value') || '';
          if (!value) return;

          const selectedValues = getSelectedValues();
          selectedValues[pickerIndex] = value;

          let variant = findVariantByValues(selectedValues);

          if (!variant) {
            variant = variants.find((candidate) => candidate.values[pickerIndex] === value) || variants[0];
          }

          setVariant(variant);
          closeAllPickers();
          if (pickerButton) pickerButton.focus({ preventScroll: true });
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (!optionRoot || optionRoot.contains(event.target)) return;
      closeAllPickers();
    });

    document.addEventListener('keydown', (event) => {
      const open = optionPickers.find((picker) => picker.classList.contains('is-open'));
      if (!open) return;

      const openButton = open.querySelector('[data-option-picker-button]');
      const enabled = Array.from(open.querySelectorAll('[data-option-picker-option]')).filter((button) => !button.disabled);

      if (event.key === 'Escape') {
        closePicker(open);
        if (openButton) openButton.focus({ preventScroll: true });
      }

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (!enabled.length) return;
        const currentIndex = enabled.indexOf(document.activeElement);
        const nextIndex = event.key === 'ArrowDown'
          ? (currentIndex + 1 + enabled.length) % enabled.length
          : (currentIndex - 1 + enabled.length) % enabled.length;
        enabled[nextIndex].focus({ preventScroll: true });
      }
    });

    variantSelect.addEventListener('change', refreshVariantState);
    refreshVariantState({ skipMediaChange: true });
  });
});

// EV PATCH - BestCustom-inspired homepage preview thumbnails, 2026-06-30
(function(){
  const galleries = document.querySelectorAll('[data-bc-home-gallery]');
  galleries.forEach((gallery) => {
    const main = gallery.querySelector('.ev-bc-hero__main-image');
    const thumbs = Array.from(gallery.querySelectorAll('[data-bc-home-thumb]'));
    if (!main || !thumbs.length || !main.tagName || main.tagName.toLowerCase() !== 'img') return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-bc-home-thumb');
        const alt = thumb.getAttribute('data-bc-home-thumb-alt') || '';
        if (!src) return;
        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        main.style.opacity = '0';
        window.setTimeout(() => {
          main.setAttribute('src', src);
          main.removeAttribute('srcset');
          main.setAttribute('alt', alt);
          main.style.opacity = '1';
        }, 120);
      });
    });
  });
})();


// EV PATCH - Product font choice dropdown block, 2026-07-06
(function () {
  const initFontPicker = (picker) => {
    if (!picker || picker.dataset.fontPickerReady === 'true') return;
    picker.dataset.fontPickerReady = 'true';

    const button = picker.querySelector('[data-font-picker-button]');
    const menu = picker.querySelector('[data-font-picker-menu]');
    const input = picker.querySelector('[data-font-picker-input]');
    const text = picker.querySelector('[data-font-picker-text]');
    const options = Array.from(picker.querySelectorAll('[data-font-picker-option]'));

    if (!button || !menu || !input || !text || !options.length) return;

    const close = () => {
      picker.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
      document.querySelectorAll('[data-font-picker].is-open').forEach((otherPicker) => {
        if (otherPicker === picker) return;
        otherPicker.classList.remove('is-open');
        const otherButton = otherPicker.querySelector('[data-font-picker-button]');
        if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
      });
      picker.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    };

    const selectOption = (option) => {
      const value = option.getAttribute('data-value') || '';
      const label = option.querySelector('[data-font-picker-label]');
      if (!value || !label) return;

      input.value = value;
      text.innerHTML = label.innerHTML;

      options.forEach((candidate) => {
        const selected = candidate === option;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-selected', String(selected));
      });

      close();
      button.focus({ preventScroll: true });
    };

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      picker.classList.contains('is-open') ? close() : open();
    });

    menu.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    options.forEach((option) => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        selectOption(option);
      });
    });

    document.addEventListener('click', (event) => {
      if (!picker.contains(event.target)) close();
    });

    document.addEventListener('keydown', (event) => {
      if (!picker.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        button.focus({ preventScroll: true });
        return;
      }

      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault();
      const currentIndex = options.indexOf(document.activeElement);
      const nextIndex = event.key === 'ArrowDown'
        ? (currentIndex + 1 + options.length) % options.length
        : (currentIndex - 1 + options.length) % options.length;
      options[nextIndex].focus({ preventScroll: true });
    });
  };

  const initAllFontPickers = () => {
    document.querySelectorAll('[data-font-picker]').forEach(initFontPicker);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFontPickers);
  } else {
    initAllFontPickers();
  }
})();
